import { generatePath, matchPath } from 'react-router'

import type { Student } from '@/dto'
import { RouteName } from '@/router/RouteName'

export const ENTRANCE_TEST_SUB_TAB = {
  worksheet: 'worksheet',
  cas: 'cas',
} as const

export type EntranceTestSubTab = ValueOf<typeof ENTRANCE_TEST_SUB_TAB>

export const getEntranceTestSubTab = (pathname: string): EntranceTestSubTab =>
  pathname.startsWith(RouteName.lessonGuestEntranceTestCas)
    ? ENTRANCE_TEST_SUB_TAB.cas
    : ENTRANCE_TEST_SUB_TAB.worksheet

export const getEntranceTestSubTabRoute = (
  subTab: EntranceTestSubTab,
  studentId?: Student['id'],
) =>
  studentId
    ? generatePath(
        subTab === ENTRANCE_TEST_SUB_TAB.cas
          ? RouteName.lessonGuestEntranceTestCasStudent
          : RouteName.lessonGuestEntranceTestWorksheetStudent,
        { studentId },
      )
    : subTab === ENTRANCE_TEST_SUB_TAB.cas
      ? RouteName.lessonGuestEntranceTestCas
      : RouteName.lessonGuestEntranceTestWorksheet

export const getEntranceTestStudentId = (pathname: string) =>
  matchPath<{ studentId: Student['id'] }>(pathname, [
    RouteName.lessonGuestEntranceTestWorksheetStudent,
    RouteName.lessonGuestEntranceTestCasStudent,
  ])?.params.studentId
